// Copyright ©️ 2026 eVolve MEP, LLC

import { TextInput, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { FormPopover, useFormPopover } from 'components/Mantine/Popovers/FormPopover';

type Props = {
  opened: boolean;
  onClose: () => void;
  onAddWebLink: (webLink: { url: string; name?: string }) => Promise<void>;
};

const AddWebLinkFields = ({ onAddWebLink }: Pick<Props, 'onAddWebLink'>) => {
  const form = useForm<{ url: string; name: string }>({
    initialValues: {
      url: '',
      name: '',
    },
    validate: {
      url: (u) => !u,
    },
  });

  useFormPopover(form, onAddWebLink);

  return (
    <Stack gap="sm">
      <TextInput
        placeholder="URL (required)"
        leftSection={<EvolveIcon size="sm" icon="External" />}
        w="100%"
        required
        autoFocus
        data-autofocus
        {...form.getInputProps('url')}
      />
      <TextInput
        placeholder="Link Name (optional)"
        leftSection={<EvolveIcon size="sm" icon="Edit" />}
        w="100%"
        {...form.getInputProps('name')}
      />
    </Stack>
  );
};

export const AddWebLinkPopover = ({ opened, onClose, onAddWebLink }: Props) => (
  <FormPopover title="Add web link" opened={opened} onClose={onClose} confirmationText="Add" position="right-start">
    <AddWebLinkFields onAddWebLink={onAddWebLink} />
  </FormPopover>
);
